import './Login.scss'
import {useState} from "react"
import { Field, Input, Button, Spinner } from "@fluentui/react-components";
import { loginUser } from '../../services/login.service';
import LoginConfirmation from './LoginConfirmation';
import { useAuth } from "../../auth/AuthProvider";
import { Navigate } from "react-router-dom";

function Login()
{
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [enableLoginButton, setEnableLoginButton] = useState(true);    
    const [loginSuccess, setLoginSuccess] = useState(false);
    const {isAuthenticated} = useAuth();    

    async function LoginUser()
    {        
        
        if(email)
        {                
            setLoading(true);
            setEnableLoginButton(false);            
            const data = await loginUser(email,{timeoutMs: 10000})
                                        .then((response) => {                                                    
                                                setLoginSuccess(response);
                                        })
                                        .catch( ex => {
                                            console.log(ex);
                                            setLoginSuccess(false);
                                            //TODO display notification
                                        })
                                        .finally(() => {
                                            setLoading(false);
                                            setEnableLoginButton(true);
                                        });
        }
    }

    
    if(isAuthenticated)
        return <Navigate to="/" replace />;
    
    return (        
        <div>           
           {!loginSuccess &&<>
            <div className='d-flex justify-content-center'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h3>Welcome, please login</h3>
                        <Field validationState={!email && 'error'} validationMessage={!email && "Email required"} size="large" required>
                            <Input type='email' placeholder='Email' aria-label='Email' onChange={(event) => setEmail(event.target.value)}/>
                        </Field>
                        {loading && <Spinner labelPosition='before' label="Login user..." />} 
                    </div>                
                </div>
            </div>
            <br/>            
            <div className='d-flex justify-content-center'>
                <div className='row'>
                    <div className='col-md-12'>
                        <Button disabledFocusable={!enableLoginButton || !email} appearance='primary' shape="circular"
                        onClick={() => LoginUser()}>Login</Button>
                    </div>                
                </div>
            </div>   
           </> }
            {loginSuccess && 
                <LoginConfirmation
                email={email}
                />
            }
        </div>
    );
}

export default Login;